import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import classNames from 'lib/util/classNames'
import SunburstSpinner from '../SunburstSpinner/SunburstSpinner'
import styles from './SunburstBackground.module.scss'

/**
 * The `SunburstBackground`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function SunburstBackground (props) {
  const { children, className, isAnimated } = props
  const classNameOutput = useMemo(
    () => classNames([className, styles.container]),
    [className]
  )

  return (
    <div className={classNameOutput}>
      <SunburstSpinner isAnimated={isAnimated} />
      {children}
    </div>
  )
}

/** @type {object} */
SunburstBackground.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isAnimated: PropTypes.bool
}

/** @type {object} */
SunburstBackground.defaultProps = {
  children: null,
  className: '',
  isAnimated: false
}

// Memoize
export default memo(SunburstBackground)
